import { render, staticRenderFns } from "./SendEmailButton.vue?vue&type=template&id=cf19bede&"
import script from "./SendEmailButton.vue?vue&type=script&lang=js&"
export * from "./SendEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf19bede')) {
      api.createRecord('cf19bede', component.options)
    } else {
      api.reload('cf19bede', component.options)
    }
    module.hot.accept("./SendEmailButton.vue?vue&type=template&id=cf19bede&", function () {
      api.rerender('cf19bede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/buttons/SendEmailButton.vue"
export default component.exports